import type { Auth0Plugin } from '@auth0/auth0-vue'
import { createAuth0 } from '@auth0/auth0-vue'
import type { App } from 'vue'

const auth0Client: Auth0Plugin = createAuth0({
  domain: __AUTH0_DOMAIN__,
  clientId: __AUTH0_CLIENT_ID__,
  useRefreshTokens: true,
  cacheLocation: 'localstorage',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: __AUTH0_AUDIENCE__,
    skipRedirectCallback: false,
    prompt: 'login',
  }
})

export default auth0Client

export const registerAuth0 = (app: App) => {
  app.use(auth0Client)
}
